import { RoleLevels, RoleNames, RolesWeight } from './../../../authentication/auth-helpers';
import { Component, OnInit, Input, EventEmitter, Output, ViewChild } from '@angular/core';
import { LoginService } from 'src/app/core/services/login.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthorizationProperties } from 'src/app/authentication/auth-info';
import { AccountRole } from 'src/app/model/account-role';
import { RolesService } from 'src/app/core/services/roles.service';
import { TbAuthService } from '@tb/auth';
import { WorkFlowService } from 'src/app/core/services/work-flow.service';
import { DateAdapter } from '@angular/material/core';
import { TranslatedVariables } from 'src/app/commons/translated-variables';
//ROLES
import { UpdateRoles, UpdateRolesInfo } from 'src/app/model/update-roles';
import { ComponentCommunicationService } from 'src/app/core/services/component-communication.service';
import { MatDialog } from '@angular/material/dialog';
import { ModelService } from 'src/app/core/services/model.service';
import { Router } from '@angular/router';
import { UserData } from '../account-management/account-management.component';
import { RolesSelectorConfig } from '../roles-selector/roles-selector.component';
import { AccountData } from 'src/app/model/account';
import { MatDatepicker } from '@angular/material/datepicker';
import { cloneDeep } from 'lodash';

@Component({
    selector: 'tb-list-users-associated',
    templateUrl: './list-users-associated.component.html',
    styleUrls: ['./list-users-associated.component.scss'],
})
export class ListUsersAssociatedComponent implements OnInit {
    // helper variables
    authorizationStored;
    authorizationProperties: AuthorizationProperties;

    accountRoles: Array<AccountRole>;
    languageOfTheUser: string;
    regionalSettingsOfTheUser: string;
    @Input() disableCheckbox: boolean = false;
    prova: RolesSelectorConfig;
    isComponentInitialized = false;
    @Input() accountDetail: AccountData;
    copyOfAccountDetail: AccountData;
    @Output() close = new EventEmitter<string>();
    @Output() rolesSaved = new EventEmitter<UpdateRoles[]>();
    //roles
    accountSelected: string;
    updateRoles: UpdateRolesInfo;
    // realRoles: UpdateRoles[] = [];
    administrativeRoles: UpdateRoles[] = [];
    applicationRoles: UpdateRoles[] = [];
    rolesResult: Array<AccountRole>;
    subscription;
    owner: boolean;
    isDevOpsOrHigher: boolean = false;
    showRoles: boolean = false;
    today = new Date();
    defaultDay = new Date();
    minDate = new Date();
    @Input() currentsubscriptionKey: string;
    // @Input() checked: boolean;
    showEditAccount: boolean = false;
    @Input() calledBySubsriptionManagement: boolean;
    dateChanged: boolean = false;
    copyOfAdministrativeRoles: UpdateRoles[] = [];
    copyOfApplicationRoles: UpdateRoles[] = [];
    listOfAccounts: UserData[] = [];

    constructor(
        private loginService: LoginService,
        private snackBar: MatSnackBar,
        private rolesService: RolesService,
        public workFlow: WorkFlowService,
        private authService: TbAuthService,
        private dateAdapter: DateAdapter<Date>,
        private variable: TranslatedVariables,
        private dialog: MatDialog,
        private modelService: ModelService,
        private router: Router,
        //roles
        private componentCommunicationService: ComponentCommunicationService
    ) {
        this.dateAdapter.setLocale('it-IT');
        if (this.authService.isSessionStorage()) {
            this.languageOfTheUser = sessionStorage.getItem('M4_ui_culture');
            this.regionalSettingsOfTheUser = sessionStorage.getItem('M4_culture');
        } else {
            this.languageOfTheUser = localStorage.getItem('M4_ui_culture');
            this.regionalSettingsOfTheUser = localStorage.getItem('M4_culture');
        }
        this.authorizationStored = this.loginService.getauthinfo();
        this.authorizationProperties = JSON.parse(this.authorizationStored);
        this.accountRoles = new Array<AccountRole>();
        this.minDate.setDate(this.today.getDate() + 1);
        //roles
        this.rolesResult = new Array<AccountRole>();
        this.updateRoles = new UpdateRolesInfo();
    }

    async ngOnInit() {
        this.setData();
        this.isComponentInitialized = true;
    }

    async ngOnChanges() {
        if (this.isComponentInitialized) {
            this.setData();
        }
    }

    // --------------------------------------------------------------------------
    copyText(inputElement) {
        inputElement.select();
        document.execCommand('copy');
    }

    setData() {
        this.copyOfAccountDetail = cloneDeep(this.accountDetail);
        this.copyOfAccountDetail.ExpirationDate = new Date(this.copyOfAccountDetail.ExpirationDate);
        this.defaultDay.setMonth(this.copyOfAccountDetail.ExpirationDate.getMonth());
        this.defaultDay.setFullYear(this.copyOfAccountDetail.ExpirationDate.getFullYear());
        this.defaultDay.setDate(this.copyOfAccountDetail.ExpirationDate.getDate());
        let selectedRoles;
        if (this.calledBySubsriptionManagement) {
            selectedRoles = this.accountDetail.Roles.split(',');
        } else {
            selectedRoles = this.accountDetail.Roles;
        }
        this.prova = {
            Roles: selectedRoles.map((x) => ({
                roleName: x,
                roleLevel: RoleLevels.Subscription,
                selected: true,
                accountSelected: this.accountDetail.AccountName,
                subscription: this.currentsubscriptionKey,
                parentAccountName: this.authorizationProperties.accountName,
                disableCheckbox: this.disableCheckbox,
                needsLevelAll: false,
            })),
        };
        this.updateSectionRoles();
        this.getAccountHomeInfo();
    }

    //ROLES

    disableRole(Role: any) {
        return (
            Role.Weight === RolesWeight.PUBLIC ||
            (Role.Weight === RolesWeight.USERADMIN && !this.owner && !this.isDevOpsOrHigher) ||
            (Role.Weight === RolesWeight.USERADMIN && this.prova.Roles[0].disableCheckbox && Role.Value && !Role.IsModified)
        );
    }

    // --------------------------------------------------------------------------------
    onValueChange(event: any, i: number, typesOfRoles: string) {
        // if (this.realRoles[i].Value === event.checked) {
        //   this.realRoles[i].IsModified = false;
        // } else {
        //   this.realRoles[i].IsModified = true;
        // }
        if (typesOfRoles === 'applicationRoles') {
            if (this.applicationRoles[i].Value === event.checked) {
                this.applicationRoles[i].IsModified = false;
            } else {
                this.applicationRoles[i].IsModified = true;
            }
        } else if (typesOfRoles === 'administrativeRoles') {
            if (this.administrativeRoles[i].Value === event.checked) {
                this.administrativeRoles[i].IsModified = false;
            } else {
                this.administrativeRoles[i].IsModified = true;
            }
        }
    }

    // -----------------------------------------------------------------------------------------------

    async updateSectionRoles() {
        // this.realRoles = [];
        this.administrativeRoles = [];
        this.applicationRoles = [];
        this.copyOfAdministrativeRoles = [];
        this.copyOfApplicationRoles = [];
        this.subscription = this.prova.Roles[0].subscription;
        this.accountSelected = this.prova.Roles[0].accountSelected;

        this.owner = this.authorizationProperties.roles.some(
            (x) => x.EntityKey === this.subscription && x.RoleLevel === RoleLevels.Subscription && x.Weight === RolesWeight.USERADMIN
        );
        this.isDevOpsOrHigher = this.rolesService.checkRolesMin(RolesWeight.DEVOPS);
        this.rolesService
            .GetListRolesToAssociate(this.prova.Roles[0].parentAccountName, this.prova.Roles[0].roleLevel, this.subscription)
            .subscribe(
                (resultRoles) => {
                    this.accountRoles = resultRoles['Content'] as AccountRole[];
                    let applicationRoles = this.accountRoles.filter((x) => x.Weight >= 100);
                    let administrativeRoles = this.accountRoles.filter((x) => x.Weight < 100 && x.Weight !== 2);

                    if (this.accountRoles.length === 0) {
                        return;
                    }
                    // for (var j: number = 0; j < this.accountRoles.length; j++) {
                    //   let existRole = this.prova.Roles.some((k) => k.roleName.trim() === this.accountRoles[j].RoleName);
                    //   this.realRoles.push({
                    //     RoleName: this.accountRoles[j].RoleName,
                    //     Description: this.accountRoles[j].Description,
                    //     Value: existRole,
                    //     IsModified: false
                    //   });
                    // }
                    for (var j: number = 0; j < administrativeRoles.length; j++) {
                        let existRole = this.prova.Roles.some((k) => k.roleName.trim() === administrativeRoles[j].RoleName);
                        this.administrativeRoles.push({
                            RoleName: administrativeRoles[j].RoleName,
                            Description: administrativeRoles[j].Description,
                            Value: existRole,
                            IsModified: false,
                            AccountName: this.accountSelected,
                            Weight: administrativeRoles[j].Weight,
                        });
                        this.copyOfAdministrativeRoles.push({
                            RoleName: administrativeRoles[j].RoleName,
                            Description: administrativeRoles[j].Description,
                            Value: existRole,
                            IsModified: false,
                            AccountName: this.accountSelected,
                            Weight: administrativeRoles[j].Weight,
                        });
                    }
                    for (var j: number = 0; j < applicationRoles.length; j++) {
                        let existRole = this.prova.Roles.some((k) => k.roleName.trim() === applicationRoles[j].RoleName);
                        this.applicationRoles.push({
                            RoleName: applicationRoles[j].RoleName,
                            Description: applicationRoles[j].Description,
                            Value: existRole,
                            IsModified: false,
                            AccountName: this.accountSelected,
                            Weight: applicationRoles[j].Weight,
                        });
                        this.copyOfApplicationRoles.push({
                            RoleName: applicationRoles[j].RoleName,
                            Description: applicationRoles[j].Description,
                            Value: existRole,
                            IsModified: false,
                            AccountName: this.accountSelected,
                            Weight: applicationRoles[j].Weight,
                        });
                    }
                    // this.realRoles.filter();
                    this.showRoles = true;
                },
                (err) => {
                    this.workFlow.showMessage(this.variable.roles, err.message);
                }
            );
    }

    // --------------------------------------------------------------------------------
    onSaveChanges(applicationRoles: UpdateRoles[], administrativeRoles: UpdateRoles[]) {
        let accountRoleToAdd: UpdateRoles[] = [];
        for (let i = 0; i < administrativeRoles.length; i++) {
            accountRoleToAdd.push(administrativeRoles[i]);
        }
        for (let i = 0; i < applicationRoles.length; i++) {
            accountRoleToAdd.push(applicationRoles[i]);
        }

        // stringhe vuote per evitare che su db venisse inserito, sui ruoli con level account (internal, devel, devosp, sysad),
        // la quaterna (accountName, ruolo, ACCOUNT, *) quando in realtà ci deve essere (accountName, ruolo, *, *)
        //  ma solo * veniva visto come tentativo di sqlInjection
        if (this.prova.Roles[0].needsLevelAll) {
            this.prova.Roles[0].roleLevel = '';
        }
        this.updateRoles.assign(
            this.subscription,
            this.prova.Roles[0].roleLevel,
            this.accountSelected,
            this.authorizationProperties.accountName,
            accountRoleToAdd
        );

        this.rolesService.updateRoleAssociation(this.updateRoles).subscribe(
            (res) => {
                if (!res.Result) {
                    // this.closeDialog();
                    this.snackBar.open(`${this.variable.operationFailed}${res.Message}`, 'OK', { duration: 5000 });
                    return;
                }
                let newAdministrativeRoles = administrativeRoles.filter((x) => x.IsModified === true);
                let newApplicationRoles = applicationRoles.filter((x) => x.IsModified === true);
                let roles: UpdateRoles[] = [];
                for (let i = 0; i < newAdministrativeRoles.length; i++) {
                    roles.push(newAdministrativeRoles[i]);
                }
                for (let i = 0; i < newApplicationRoles.length; i++) {
                    roles.push(newApplicationRoles[i]);
                }
                this.rolesSaved.emit(roles);
                this.componentCommunicationService.sendMessage(this.updateRoles);
                this.snackBar.open(this.variable.operationSucceeded, 'OK', { duration: 5000 });
            },
            (err) => {
                // this.closeDialog();
                this.snackBar.open(`${this.variable.errorTitle}${err.message}`, 'OK', { duration: 5000 });
                // this.workFlow.showMessage(this.errorTitle, err.message);
            }
        );
    }

    closeDrawer() {
        this.close.emit(this.accountDetail.AccountName);
    }

    setDate(value: Date) {
        let d = new Date();
        let h = d.getHours();
        let m = d.getMinutes();
        let s = d.getSeconds();
        value.setHours(h);
        value.setMinutes(m);
        value.setSeconds(s);

        return value;
    }

    eDateValueChange(selectedValue: any, isClicked: boolean) {
        if (isClicked) {
            if (!selectedValue.datepickerInput.getStartValue()) {
                return;
            }
            this.accountDetail.ExpirationDate = this.setDate(selectedValue.datepickerInput.getStartValue());
            if (
                this.copyOfAccountDetail.ExpirationDate.getFullYear() !== this.accountDetail.ExpirationDate.getFullYear() ||
                this.copyOfAccountDetail.ExpirationDate.getDate() !== this.accountDetail.ExpirationDate.getDate() ||
                this.copyOfAccountDetail.ExpirationDate.getMonth() !== this.accountDetail.ExpirationDate.getMonth()
            ) {
                this.dateChanged = true;
            } else {
                this.dateChanged = false;
            }
            return;
        }
        this.dateChanged = false;
        this.accountDetail.ExpirationDate = this.defaultDay;
    }

    async addAccountSubscriptionAssociation(accname: string, expirationDate: Date, isHeChangingExpDate: boolean) {
        this.modelService.addAccountSubscriptionAssociation(accname, this.subscription, expirationDate).subscribe(async (res) => {
            const opResResult: boolean = res['Result'];
            const opResMessage: string = res['Message'];
            if (!opResResult) {
                this.workFlow.showMessage(this.variable.warningTitle, opResMessage);
            } else {
                if (isHeChangingExpDate) {
                    this.snackBar.open(
                        `${this.variable.snackBarMessage_2_first}${this.subscription}${this.variable.snackBarMessage_2_middle}${accname}${this.variable.snackBarMessage_2_last}`,
                        'OK',
                        { duration: 5000 }
                    );
                } else {
                    this.snackBar.open(
                        `${this.variable.snackBarMessage_1_first}${accname} ${this.variable.snackBarMessage_1_last}${this.subscription}`,
                        'OK',
                        { duration: 5000 }
                    );
                }
                this.dateChanged = false;
                this.close.emit();
                // await this.loadAssociatedAccounts();
            }
        });
    }

    goToAccountDetails(accountName: string) {
        this.router.navigate(['/account-management'], {
            queryParams: { accountToEdit: accountName },
        });
    }

    showMoreInfo() {
        this.showEditAccount = true;
    }

    cancel() {
        this.administrativeRoles = [];
        this.applicationRoles = [];
        for (var j: number = 0; j < this.copyOfAdministrativeRoles.length; j++) {
            this.administrativeRoles.push({
                RoleName: this.copyOfAdministrativeRoles[j].RoleName,
                Description: this.copyOfAdministrativeRoles[j].Description,
                Value: this.copyOfAdministrativeRoles[j].Value,
                IsModified: this.copyOfAdministrativeRoles[j].IsModified,
                AccountName: this.accountSelected,
                Weight: this.copyOfAdministrativeRoles[j].Weight,
            });
        }
        for (var j: number = 0; j < this.copyOfApplicationRoles.length; j++) {
            this.applicationRoles.push({
                RoleName: this.copyOfApplicationRoles[j].RoleName,
                Description: this.copyOfApplicationRoles[j].Description,
                Value: this.copyOfApplicationRoles[j].Value,
                IsModified: this.copyOfApplicationRoles[j].IsModified,
                AccountName: this.accountSelected,
                Weight: this.copyOfApplicationRoles[j].Weight,
            });
        }
    }

    nothingHasChanged() {
        if (
            JSON.stringify(this.administrativeRoles) === JSON.stringify(this.copyOfAdministrativeRoles) &&
            JSON.stringify(this.applicationRoles) === JSON.stringify(this.copyOfApplicationRoles)
        ) {
            return true;
        }
        return false;
    }

    async getAccountHomeInfo() {
        let opRes = await this.modelService.getAccountHomeInfoToPromise(this.authorizationProperties.accountName);
        if (!opRes.Result || opRes['Content'].length === 0) {
            return;
        }
        this.listOfAccounts = opRes['Content'].filter(
            (x) => x.AccountName !== 'root.cloud@microarea.it' && x.AccountName !== this.authorizationProperties.accountName
        );
    }

    isEditable(accountName: string) {
        if (this.listOfAccounts) {
            let accountNameIsEditable = this.listOfAccounts.filter((x) => x.AccountName === accountName).map((x) => x.IsEditable)[0];
            if (this.calledBySubsriptionManagement && accountNameIsEditable) {
                return true;
            }
            return false;
        }
        return false;
    }
}
